import React from 'react'
import { withIcon } from '../../withIcon'

function FacebookIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.0225 4.02252C11.0774 2.96763 12.5082 2.375 14 2.375H17C17.3452 2.375 17.625 2.65482 17.625 3V7C17.625 7.34518 17.3452 7.625 17 7.625H14C13.9005 7.625 13.8052 7.66451 13.7348 7.73484C13.6645 7.80516 13.625 7.90054 13.625 8V9.375H17C17.1925 9.375 17.3742 9.46367 17.4926 9.61537C17.6111 9.76707 17.653 9.96487 17.6063 10.1516L16.6063 14.1516C16.5368 14.4298 16.2868 14.625 16 14.625H13.625V21C13.625 21.3452 13.3452 21.625 13 21.625H9C8.65482 21.625 8.375 21.3452 8.375 21V14.625H6C5.65482 14.625 5.375 14.3452 5.375 14V10C5.375 9.65482 5.65482 9.375 6 9.375H8.375V8C8.375 6.50816 8.96763 5.07742 10.0225 4.02252ZM14 3.625C12.8397 3.625 11.7269 4.08594 10.9064 4.90641C10.0859 5.72688 9.625 6.83968 9.625 8V10C9.625 10.3452 9.34518 10.625 9 10.625H6.625V13.375H9C9.34518 13.375 9.625 13.6548 9.625 14V20.375H12.375V14C12.375 13.6548 12.6548 13.375 13 13.375H15.512L16.1995 10.625H13C12.6548 10.625 12.375 10.3452 12.375 10V8C12.375 7.56902 12.5462 7.1557 12.851 6.85095C13.1557 6.54621 13.569 6.375 14 6.375H16.375V3.625H14Z" fill={color}/>
    </svg>
  )
}

export default withIcon(FacebookIcon)
